import _ from 'underscore';
import pageContext from '@bingads-webui-static-legacy/page-context';

import { BaseGridColumn } from '../base-grid-column';
import deliveryStatusTemplate from './delivery-status-template.pug';
import { deliveryStatusBaseColumn } from '@bingads-webui-campaign-legacy/campaigns-tab-campaigns/grid/columns-config-base';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');

class DeliveryStatusColumn extends BaseGridColumn {
  constructor() {
    super();

    const deliveryStatusColumn = deliveryStatusBaseColumn();

    this.setName(deliveryStatusColumn.name);
    this.setSortable('DeliveryStatus');
    this.setTitle(i18n.get('ColumnName_DeliveryStatus'));
    this.setProperties(deliveryStatusColumn.property);
    this.setHelpId('Page_CampaignGrids_Delivery');
  }

  template(model) {
    let name = model.Name;

    if (_.isUndefined(name) && !_.isUndefined(model.AdGroup)) {
      name = model.AdGroup.Name;
    }
    if (_.isUndefined(name) && !_.isUndefined(model.Campaign)) {
      name = model.Campaign.Name;
    }

    this.campaignEntityObject = {
      Name: name,
      Id: model.Id,
    };

    const params = {
      Id: model.Id,
      DeliveryStatus: model.DeliveryStatus,
      i18n,
      Budget: model.Budget,
      IsAppealable: model.IsAppealable,
    };

    if (_.result(pageContext.Permissions, 'IsExperimentsOpenBetaEnabled') && model.ExperimentId && model.AssociatedExperiment) {
      params.showEllipsisForExperiment = true;
    }

    return deliveryStatusTemplate(params);
  }
}

export { DeliveryStatusColumn };
